import * as React from "react";
import LinkButton from "../../components/LinkButton";
import { UserStatus } from "../../generated/lib-domain/user";
import { URL_PATHS } from "../../routes";
import { Props } from "../../types/common";
import "./styles.scss";
import { oneLink } from "../../shared/oneLink";
import AnchorButton from "../../components/AnchorButton";
import {
    CardPaymentPlan,
    PaymentPlanEnum,
    PaymentStatusObj,
    SubscriptionEnum
} from "../../generated/UserAPIAgent";
import { PAYMENT_PLANS } from "../../generated/lib-domain/paymentPlan";
import CampaignMessage from "../../components/Messages/CampaignMessage";
import PriceDifference from "../../components/Messages/PriceDifference";

interface UserActionProps extends Props {
    status: number;
    isPaid: boolean;
    paymentStatus: PaymentStatusObj | null;
    standardCardPaymentPlan: CardPaymentPlan;
}

const UserAction = (props: UserActionProps) => {
    const standardCardPlan = PAYMENT_PLANS.find(
        (plan) => plan.id === PaymentPlanEnum.STANDARD_1M_CARD_9800
    );
    if (props.status === UserStatus.Created) {
        // 未登録
        return (
            <>
                <p className="myPage__not-active-label">
                    登録が完了していません。
                    <br />
                    アプリを開いて登録を完了させてください。
                </p>
                <AnchorButton href={oneLink()}>アプリを開く</AnchorButton>
            </>
        );
    } else if (props.isPaid) {
        // 有料会員
        return (
            <>
                <LinkButton to={URL_PATHS.paymentInfo()} color="primary">
                    決済情報を確認
                </LinkButton>
                {props.paymentStatus?.currentPaymentPlan?.subscription ===
                    SubscriptionEnum.LITE &&
                    props.paymentStatus
                        ?.cardPaymentTransitionApplicationDate === null && (
                        // ライトプラン加入中でカード決済切り替え待ちではないユーザー
                        <div className="myPage__plan-info">
                            <p>
                                {
                                    PAYMENT_PLANS.find(
                                        (plan) =>
                                            plan.id ===
                                            PaymentPlanEnum.STANDARD_1M_CARD_9800
                                    ).message.title
                                }
                            </p>
                            <div>
                                <h2 className="myPage__plan-title">
                                    {standardCardPlan.title}
                                </h2>
                                <h3 className="myPage__plan-title">
                                    月額{standardCardPlan.amount}円
                                </h3>
                            </div>
                            {props.standardCardPaymentPlan.campaigns.length >
                                0 && (
                                // 適用するキャンペーンがある場合
                                <CampaignMessage
                                    message={{
                                        title: props.standardCardPaymentPlan
                                            .campaigns[0].title,
                                        description:
                                            props.standardCardPaymentPlan
                                                .campaigns[0].description
                                    }}
                                />
                            )}
                            <LinkButton
                                to={URL_PATHS.paymentPlan()}
                                lines={2}
                                color="primary"
                            >
                                {standardCardPlan.title}詳細を確認する
                            </LinkButton>
                        </div>
                    )}
            </>
        );
    } else {
        // 無料会員
        return (
            <>
                <LinkButton to={URL_PATHS.paymentInfo()} color="primary">
                    決済情報を確認
                </LinkButton>
                {
                    <PriceDifference
                        subscription={SubscriptionEnum.STANDARD}
                        addText={false}
                        isNotPaidMember={
                            props.paymentStatus?.currentPaymentPlan === null
                        }
                    />
                }
                <LinkButton
                    to={URL_PATHS.paymentPlan()}
                    lines={2}
                    color="primary"
                >
                    有料会員プランに登録する
                </LinkButton>
            </>
        );
    }
};

export default UserAction;
